module.exports = __webpack_public_path__ + "img/7.b75e5a30.jpg";